import { NewLesson } from "@/pages/planning/NewLesson"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useRouter } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/lessen/nieuwe-les")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "planning"),
})

function RouteComponent() {
  const router = useRouter()

  const handleSuccess = async () => {
    router.navigate({
      to: "/beheer/lessen",
      replace: true,
    })
  }

  return <NewLesson handleSuccess={handleSuccess} />
}
